import React from "react";
import VLLogo from "assets/img/VL-Beta-Logo.svg";

import styles from "./style.module.scss";
import classNames from "classnames";

const VLIcon = ({ className }: { className?: string }) => {
  return (
    <div className={classNames(styles.vlLogo, className)}>
      <img src={VLLogo} alt="" />
    </div>
  );
};

export default React.memo(VLIcon);
